<div class="popup1">
  <mat-icon mat-dialog-close class="close">close</mat-icon>
  <p>
    Your policy provides coverage for a catastrophic ground cover collapse that
    results in the property being condemned and uninhabitable otherwise, your
    policy does not provide coverage for sinkhole losses.
  </p>
</div>
